module.exports = __webpack_public_path__ + "2e3d98ddf094e8c977322aed721e7a1b.pdf";